import { Session } from "@supabase/supabase-js";
import { Link, useLocation } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { MascotAvatar } from "./MascotAvatar";

export default function Layout({
  session,
  children,
}: {
  session: Session;
  children: React.ReactNode;
}) {
  const location = useLocation();

  return (
    <div className="flex h-screen flex-col">
      <header className="flex items-center justify-between border-b border-border bg-bg-elevated/80 px-5 py-2.5 backdrop-blur">
        <div className="flex items-center gap-5">
          <Link to="/" className="flex items-center gap-2.5">
            <MascotAvatar size={28} />
            <span className="font-display text-base font-semibold tracking-display text-text">
              LMT <span className="text-text-muted">DM Setter</span>
            </span>
          </Link>
          <nav className="flex gap-1 text-xs">
            <Link
              to="/"
              className={`rounded-md px-2.5 py-1 font-medium transition-colors ${
                location.pathname === "/"
                  ? "bg-bg-hover text-text"
                  : "text-text-muted hover:bg-bg-hover hover:text-text"
              }`}
            >
              Inbox
            </Link>
          </nav>
        </div>
        <div className="flex items-center gap-3 text-xs">
          <span className="text-text-muted">{session.user.email}</span>
          <button
            onClick={() => supabase.auth.signOut()}
            className="rounded-md border border-border px-2.5 py-1 text-text-muted hover:bg-bg-hover hover:text-text"
          >
            Sign out
          </button>
        </div>
      </header>
      <main className="flex-1 overflow-hidden">{children}</main>
    </div>
  );
}
